import { requestWithFallback } from '../httpClient';

export async function getPerfilResumen(token) {
    const result = await requestWithFallback({
        moduleName: 'perfil',
        endpoint: 'summary',
        endpointIsKey: true,
        method: 'get',
        token,
    });

    return result.data;
}

export async function updatePerfilPassword(token, payload) {
    const result = await requestWithFallback({
        moduleName: 'perfil',
        endpoint: 'password',
        endpointIsKey: true,
        method: 'post',
        token,
        data: payload,
    });

    return result.data;
}

export async function updatePerfilInitialPassword(token, payload) {
    const result = await requestWithFallback({
        moduleName: 'perfil',
        endpoint: 'passwordInicial',
        endpointIsKey: true,
        method: 'post',
        token,
        data: payload,
    });

    return result.data;
}

export async function updatePerfilPinFirma(token, payload) {
    const result = await requestWithFallback({
        moduleName: 'perfil',
        endpoint: 'pinFirma',
        endpointIsKey: true,
        method: 'post',
        token,
        data: payload,
    });

    return result.data;
}

export async function updatePerfilContacto(token, payload) {
    const result = await requestWithFallback({
        moduleName: 'perfil',
        endpoint: 'contacto',
        endpointIsKey: true,
        method: 'patch',
        token,
        data: payload,
    });

    return result.data;
}

export async function enablePerfilTwoFactor(token, payload) {
    const result = await requestWithFallback({
        moduleName: 'perfil',
        endpoint: 'twoFactorEnable',
        endpointIsKey: true,
        method: 'post',
        token,
        data: payload,
    });

    return result.data;
}

export async function confirmPerfilTwoFactor(token, payload) {
    const result = await requestWithFallback({
        moduleName: 'perfil',
        endpoint: 'twoFactorConfirm',
        endpointIsKey: true,
        method: 'post',
        token,
        data: payload,
    });

    return result.data;
}

export async function disablePerfilTwoFactor(token, payload) {
    const result = await requestWithFallback({
        moduleName: 'perfil',
        endpoint: 'twoFactorDisable',
        endpointIsKey: true,
        method: 'post',
        token,
        data: payload,
    });

    return result.data;
}

export async function regeneratePerfilTwoFactorCodes(token, payload) {
    const result = await requestWithFallback({
        moduleName: 'perfil',
        endpoint: 'twoFactorRegenerateCodes',
        endpointIsKey: true,
        method: 'post',
        token,
        data: payload,
    });

    return result.data;
}

export async function updatePerfilFirma(token, payload) {
    const result = await requestWithFallback({
        moduleName: 'perfil',
        endpoint: 'firma',
        endpointIsKey: true,
        method: 'post',
        token,
        data: payload,
    });

    return result.data;
}
